import { render } from "./PopUp.vue?vue&type=template&id=45afde18&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=45afde18&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45afde18"]])

export default __exports__